var dt = document.getElementById('timeWrap').dataset.date;
var exp = document.getElementById('timeWrap').dataset.expired;

// Set the date we're counting down to
var countDownDate = new Date(dt).getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  document.getElementById("countdownWrapper").innerHTML = `<div class="timeWrapper"><span class="time">${days}</span><small>Days</small></div>
  <div class="timeWrapper"><span class="time">${hours}</span><small>Hrs</small></div>
  <div class="timeWrapper"><span class="time">${minutes}</span><small>Mins</small></div>
  <div class="timeWrapper"><span class="time">${seconds}</span><small>Secs</small></div>`;

  // If the count down is finished, write some text
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("timeWrap").innerHTML = exp;
  }
}, 1000);